import { render, staticRenderFns } from "./LeaderboardDesktop.vue?vue&type=template&id=133744d7&"
import script from "./LeaderboardDesktop.vue?vue&type=script&lang=js&"
export * from "./LeaderboardDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports